import type { RootState } from '~/redux/store';
import type { Email } from '~/types/models';
import type { IRestIndexParams } from '~/types/states';

export const getParams = (state: RootState): IRestIndexParams<Email> => ({
  sortBy: state.emails.sortBy,
  page: state.emails.page,
  pageSize: state.emails.pageSize,
  with: state.emails.with.join(','),
  ...state.emails.filters,
});

export const getItem = (state: RootState): Email | null => state.emails.item;

export const getInitialItem = (state: RootState): string | null => state.emails.initialItem;
